require('./RAOKCover.scss');

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

class RAOKCover extends React.Component {
    buildCustomBackground() {
        const { backgroundUrlImage } = this.props;

        return <i style={{ backgroundImage: `url(${backgroundUrlImage})` }} />;
    }

    render() {
        const {
            customClass,
            extraClass,
            section,
            children,
            size,
            backgroundUrlImage,
        } = this.props;
        const coverClassName = classNames(
            'ra-ok-cover',
            {
                [`ra-ok-cover--${extraClass}`]: extraClass,
                [`ra-ok-cover--${size}`]: size,
                [`ra-ok-cover--${section}`]: section,
            },
            customClass,
        );
        let coverImage = <i className="ra-ok-cover__image" />;

        if (backgroundUrlImage) {
            coverImage = this.buildCustomBackground();
        }

        return (
            <div className={coverClassName}>
                {coverImage}
                <div className="ra-ok-cover__content">{children}</div>
            </div>
        );
    }
}

RAOKCover.propTypes = {
    customClass: PropTypes.string,
    extraClass: PropTypes.string,
    size: PropTypes.string,
    section: PropTypes.string,
    children: PropTypes.any,
    backgroundUrlImage: PropTypes.string,
};

RAOKCover.defaultProps = {
    section: 'pg',
};

module.exports = RAOKCover;
